// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function getTrackCoachOnboarding() {
    return await authenticatedFetch(`/v5/trackCoachOnboarding`);
}



// WEBPACK FOOTER //
// ./src/v5/home/api/getTrackCoachOnboarding.js